// src/utils/iconUtils.js

import { FaHeart, FaGavel, FaChartLine, FaExclamationTriangle, FaCloudSun, FaTheaterMasks, FaHeartBroken, FaFutbol, FaTshirt, FaFlag, FaUtensils, FaBalanceScale, FaBriefcase, FaTree, FaPaw } from 'react-icons/fa';

export const getCategoryIcon = (category) => {
    const iconStyle = { marginRight: '10px' }; // アイコンとテキストの間にスペースを追加
    const size = 25
    switch (category) {
        case '健康':
            return <FaHeart style={iconStyle} size={size} />;
        case '裁判':
            return <FaGavel style={iconStyle} size={size} />;
        case '経済':
            return <FaChartLine style={iconStyle} size={size} />;
        case '犯罪':
            return <FaExclamationTriangle style={iconStyle} size={size} />;
        case '天気':
            return <FaCloudSun style={iconStyle} size={size} />;
        case '文化':
            return <FaTheaterMasks style={iconStyle} size={size} />;
        case '恋愛':
            return <FaHeartBroken style={iconStyle} size={size} />;
        case 'スポーツ':
            return <FaFutbol style={iconStyle} size={size} />;
        case '洋服':
            return <FaTshirt style={iconStyle} size={size} />;
        case '国':
            return <FaFlag style={iconStyle} size={size} />;
        case '食べ物':
            return <FaUtensils style={iconStyle} size={size} />;
        case '政治':
            return <FaBalanceScale style={iconStyle} size={size} />;
        case '仕事':
            return <FaBriefcase style={iconStyle} size={size} />;
        case '自然':
            return <FaTree style={iconStyle} size={size} />;
        case '動物':
            return <FaPaw style={iconStyle} size={size} />;
        default:
            return <FaHeart style={iconStyle} size={size} />; // デフォルトのアイコン
    }
};
